exports.onClientEntry = () => {
  if (window.location.pathname.endsWith("/conteudo/17396/inep-volta-a-ficar-sem-presidente")) {
    window.embeddedChatbotConfig = {
      chatbotId: "A_S0Isxu1rHhWLT0RPmS3",
      domain: "www.chatbase.co",
    };

    const script$ = document.createElement("script");

    script$.src = "https://www.chatbase.co/embed.min.js";
    script$.setAttribute("chatbotId", "A_S0Isxu1rHhWLT0RPmS3");
    script$.setAttribute("domain", "www.chatbase.co");
    script$.defer = true;

    window.document.body.insertAdjacentElement("beforeend", script$);
  }

  window.setCookiesToCompleteRegistrationRedirect = (url) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + 60 * 60 * 1000);
  
    document.cookie = `ane_complemento_cadastro_redirect_url=${url};expires=${expires.toUTCString()};path=/;domain=.novaescola.org.br`;
  }
  const script = document.createElement("script");
  script.src = "https://audio4.audima.co/audima-widget.js";
  script.defer = true;
  document.body.appendChild(script);
};